import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import useBulkPlaybookUpdateTableContextProps from './useBulkPlaybookUpdateTableContextProps';

const BulkPlaybookUpdateTableContext = createContext({});

export function useBulkPlaybookUpdateTableContext() {
  return useContext(BulkPlaybookUpdateTableContext);
}

export default function BulkPlaybookUpdateTableContextProvider({ children }) {
  const contextProps = useBulkPlaybookUpdateTableContextProps();

  return (
    <BulkPlaybookUpdateTableContext.Provider value={contextProps}>{children}</BulkPlaybookUpdateTableContext.Provider>
  );
}

BulkPlaybookUpdateTableContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
